export default __webpack_public_path__ + "static/media/img35.ab013613.png";